module.exports = __webpack_public_path__ + "static/media/familyprofile.332b582f.svg";